import { Services } from '@spectorasoftware/homegauge-services';

class ApiContainer {
  constructor() {
    this.authService = null;
    this.personService = null;
    this.subscriptionService = null;
  }

  init() {
    const API_AUTH_URL = process.env.VUE_APP_AUTH_SVC_URL;
    const API_BASIC_USER = process.env.VUE_APP_AUTH_SVC_BASIC_USER;
    const API_URL = process.env.VUE_APP_API_SVC_URL;

    this.authService = new Services.AuthService(API_AUTH_URL, {}, API_BASIC_USER);
    this.personService = new Services.PersonService(API_URL);
    this.subscriptionService = new Services.SubscriptionsService(API_URL);
  }
}

export { ApiContainer };
export default new ApiContainer();
